export default "__VITE_ASSET__BxAuq94S__"